import React, { createContext, useContext, ReactNode } from 'react';
import { useWebRTC, WebRTCReturn } from 'utils/hooks/useWebRTC';

const CallContext = createContext<WebRTCReturn | null>(null);

export const useCall = () => {
  const context = useContext(CallContext);
  if (!context) {
    throw new Error('useCall must be used within CallProvider');
  }
  return context;
};

export const CallProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const Call = useWebRTC();

  return (
    <CallContext.Provider value={Call}>
      {children}
      {/*  hidden audio element for local stream */}
      {Call.localStream && (
        <audio
          ref={audio => {
            if (audio) audio.srcObject = Call.localStream;
          }}
          autoPlay
          muted
          style={{ display: 'none' }}
        />
      )}
    </CallContext.Provider>
  );
};
